(function () {
  'use strict';

  if (window.__pdCarousel) return;
  window.__pdCarousel = true;

  var initialized = false;
  var gap = 16;

  function initBundleCarousel() {
    if (initialized) return;

    var track = document.querySelector('.bndlr-mnm-available-products');
    if (!track) return;

    var cards = Array.from(track.querySelectorAll('.bndlr-product.bndlr-mix-and-match'));
    if (cards.length === 0) return;

    initialized = true;
    track.style.transform = 'translateX(0px)';

    var trackWrap = document.createElement('div');
    trackWrap.className = 'bndlr-carousel-track-wrap';
    track.parentNode.insertBefore(trackWrap, track);
    trackWrap.appendChild(track);

    var outer = document.createElement('div');
    outer.className = 'bndlr-carousel-outer';
    trackWrap.parentNode.insertBefore(outer, trackWrap);
    outer.appendChild(trackWrap);

    var prevBtn = document.createElement('button');
    prevBtn.className = 'bndlr-carousel-btn bndlr-carousel-btn--prev';
    prevBtn.setAttribute('aria-label', 'Previous');
    prevBtn.innerHTML = '<svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"></polyline></svg>';

    var nextBtn = document.createElement('button');
    nextBtn.className = 'bndlr-carousel-btn bndlr-carousel-btn--next';
    nextBtn.setAttribute('aria-label', 'Next');
    nextBtn.innerHTML = '<svg viewBox="0 0 24 24"><polyline points="9 6 15 12 9 18"></polyline></svg>';

    outer.appendChild(prevBtn);
    outer.appendChild(nextBtn);

    var dotsContainer = document.createElement('div');
    dotsContainer.className = 'bndlr-carousel-dots';
    outer.parentNode.insertBefore(dotsContainer, outer.nextSibling);

    var currentIndex = 0;

    function getContainerWidth() {
      var tw = trackWrap.offsetWidth;
      if (tw > 50) return tw - 16;
      return document.documentElement.clientWidth - 48;
    }

    function getVisibleCount() {
      var cw = getContainerWidth();
      if (cw <= 300) return 1;
      if (cw <= 500) return 2;
      return 4;
    }

    function getCardWidth() {
      var cw = getContainerWidth();
      var visible = getVisibleCount();
      var totalGaps = (visible - 1) * gap;
      return Math.floor((cw - totalGaps) / visible);
    }

    function setSizes() {
      var w = getCardWidth();
      cards.forEach(function (card) {
        card.setAttribute('style',
          'flex: 0 0 ' + w + 'px !important;' +
          'width: ' + w + 'px !important;' +
          'max-width: ' + w + 'px !important;' +
          'min-width: ' + w + 'px !important;' +
          'box-sizing: border-box !important;'
        );
      });
    }

    function getMaxIndex() {
  var visible = getVisibleCount();
  var cardW = getCardWidth();
  var totalWidth = cards.length * cardW + (cards.length - 1) * gap;
  var containerW = getContainerWidth();
  var maxScroll = totalWidth - containerW;
  var maxByScroll = Math.ceil(maxScroll / (cardW + gap));
  return Math.min(Math.max(0, cards.length - visible), maxByScroll);
}

    function buildDots() {
      dotsContainer.innerHTML = '';
      for (var i = 0; i <= getMaxIndex(); i++) {
        (function (idx) {
          var dot = document.createElement('button');
          dot.className = 'bndlr-carousel-dot' + (idx === 0 ? ' active' : '');
          dot.setAttribute('aria-label', 'Slide ' + (idx + 1));
          dot.addEventListener('click', function () { goTo(idx); });
          dotsContainer.appendChild(dot);
        })(i);
      }
    }

    function updateDots() {
      var dots = dotsContainer.querySelectorAll('.bndlr-carousel-dot');
      dots.forEach(function (d, i) {
        d.classList.toggle('active', i === currentIndex);
      });
    }

    function goTo(index) {
  var max = getMaxIndex();
  currentIndex = Math.max(0, Math.min(index, max));
  var cardW = getCardWidth();
  var maxOffset = (cards.length - 1) * (cardW + gap);
  var offset = Math.min(currentIndex * (cardW + gap), maxOffset);
  track.style.transform = 'translateX(-' + offset + 'px)';
  prevBtn.disabled = currentIndex === 0;
  nextBtn.disabled = currentIndex >= max;
  updateDots();
}

    prevBtn.addEventListener('click', function () { goTo(currentIndex - 1); });
    nextBtn.addEventListener('click', function () { goTo(currentIndex + 1); });

    var touchStartX = 0;
    var touchStartY = 0;
    var touchStartIndex = 0;
    var touchActive = false;

    outer.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchStartIndex = currentIndex;
      touchActive = true;
    }, { passive: true });

    outer.addEventListener('touchend', function (e) {
      if (!touchActive) return;
      touchActive = false;
      var diffX = touchStartX - e.changedTouches[0].clientX;
      var diffY = touchStartY - e.changedTouches[0].clientY;
      if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 30) {
        goTo(touchStartIndex + (diffX > 0 ? 1 : -1));
      }
    }, { passive: true });

    outer.addEventListener('touchcancel', function () {
      touchActive = false;
    }, { passive: true });

    var isDragging = false;
    var dragStartX = 0;
    var dragStartIndex = 0;

    track.addEventListener('mousedown', function (e) {
      // Don't intercept clicks on interactive elements
      if (e.target.closest('select, button, input, a, label')) return;
      isDragging = true;
      dragStartX = e.clientX;
      dragStartIndex = currentIndex;
      track.classList.add('is-dragging');
      e.preventDefault();
    });

    window.addEventListener('mousemove', function (e) {
      if (!isDragging) return;
      var diff = dragStartX - e.clientX;
      var moved = Math.round(diff / (getCardWidth() + gap));
      goTo(dragStartIndex + moved);
    });

    window.addEventListener('mouseup', function () {
      if (!isDragging) return;
      isDragging = false;
      track.classList.remove('is-dragging');
    });

    var lastWidth = window.innerWidth;
    var resizeTimer;
    window.addEventListener('resize', function () {
      if (window.innerWidth === lastWidth) return;
      lastWidth = window.innerWidth;
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        setSizes();
        buildDots();
        goTo(Math.min(currentIndex, getMaxIndex()));
      }, 300);
    });

    setTimeout(function () {
      setSizes();
      buildDots();
      goTo(0);
    }, 100);
  }

  var pollAttempts = 0;
  var pollInterval = setInterval(function () {
    pollAttempts++;
    var t = document.querySelector('.bndlr-mnm-available-products');
    if (t && t.querySelectorAll('.bndlr-product').length > 0) {
      clearInterval(pollInterval);
      setTimeout(initBundleCarousel, 600);
    }
    if (pollAttempts > 20) clearInterval(pollInterval);
  }, 500);

})();
